import React from 'react';
import './asbv-disclaimer.scss';
import { Container, Grid } from '@material-ui/core';
import { AppConstants } from 'constants/app-constants.enum';

/**
 * Displays a disclaimer about ASBV information in a container.
 */
export const ASBVDisclaimer: React.FC = () => (
  <Container className="sg-asbv-disclaimer">
    <Grid
      container
      justify="center"
      spacing={3}
    >
      <Grid
        item
        xs={10}
        sm={8}
      >
        <p>{AppConstants.FooterLegal}</p>
      </Grid>
    </Grid>
  </Container>
);
